import { PostcardTemplateData } from "../../types/postcard";
import { Paper, Box } from "@mui/material";
import { useState, useEffect } from "react";

interface PostcardPreviewProps {
    frontTemplate: string;
    rearTemplate: string;
    data: PostcardTemplateData;
    postcardImage: string;
  }

export const PostcardPreview: React.FC<PostcardPreviewProps> = ({ frontTemplate, rearTemplate, data, postcardImage }) => {
    const [previewHtml, setPreviewHtml] = useState<{ front: string; rear: string }>({ front: '', rear: '' });
  
    useEffect(() => {
      const frontHtml = frontTemplate.replace('{{imageUrl}}', postcardImage);
  
      // Format recipient address, each line is separated by a new line
      const formattedAddress = `${data.recipientAddress.name}\n${data.recipientAddress.address_line1}\n${data.recipientAddress.address_line2 ? data.recipientAddress.address_line2 + '\n' : ''}${data.recipientAddress.address_city}\n${data.recipientAddress.address_state}\n${data.recipientAddress.address_zip}\n${data.recipientAddress.address_country}`;
      let rearHtml = rearTemplate.replace('{{recipientAddress}}', formattedAddress);
      rearHtml = rearHtml.replace('{{message}}', data.message);
      setPreviewHtml({ 
          front: frontHtml, 
          rear: rearHtml
      });
    }, [data, frontTemplate, rearTemplate, postcardImage]);
  
    return (
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
        <Paper 
          elevation={3} 
          sx={{ 
            width: '148mm', 
            height: '105mm',
            overflow: 'hidden',
            '& iframe': {
              border: 'none',
              width: '100%',
              height: '100%',
            }
          }}
        >
          <iframe srcDoc={previewHtml.front} title="Front Preview" />
        </Paper>
        <Paper 
          elevation={3} 
          sx={{ 
            width: '148mm', 
            height: '105mm',
            overflow: 'hidden',
            '& iframe': {
              border: 'none',
              width: '100%',
              height: '100%',
            }
          }}
        >
          <iframe srcDoc={previewHtml.rear} title="Rear Preview" />
        </Paper>
      </Box>
    );
  };